module.exports = __webpack_public_path__ + "media/images/athletes/487-8fbec501ae8deb6fb6f224756e72bfa6.png";